import store from "@/store";

function SocketAck(events, eventType) {
  this.events = events;
  this.eventType = eventType;

  this.onDisConnect;

  this.DisConnectAck = () => {
    if (this.onDisConnect) {
      setTimeout(() => {
        this.onDisConnect(); // 重新连接
      }, 5000);
    }

    store.dispatch("app/disConnectSocket");
  };
  this.ConnectAck = () => {
    store.dispatch("app/connectSocket");
  };

  //单车最后位置应答
  this.GetVelLastGPSExAck = (Paras) => {
    // if (Paras && Paras != "")
    //     Paras = Paras.replace("\"\{", "[\{").replace("\}\"", "\}]");
    // console.log(Paras)

    // var params = JSON.parse(Paras);
    this.events.items(this.eventType.onGetVelLastGPSExAck).run(Paras);

    //     this.events.items(this.eventType.onGetVelLastGPSExAck).run({

    //     mobile: Paras.v_strPhone,
    //     msgId: Paras.v_strMsgID,
    //     result: Paras.v_byResult,
    //   });
  };
  this.TakePhotoAck = (Paras) => {
    this.events.items(this.eventType.onTakePhotoAck).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      result: Paras.v_byResult,
    });
  };
  this.ReceiveMultiMediaAbnormal = (Paras) => {
    this.events.items(this.eventType.onReceiveMultiMediaAbnormal).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      result: Paras.v_byFlag,
    });
  };
  this.ReceivePhoto = (Paras) => {
    this.events.items(this.eventType.onReceivePhoto).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      totalRecord: Paras.v_uiTotalRecord,
      currentRecord: Paras.v_uiCurrentRecord,
    });
  };

  this.ReceivePhotoComplete = (Paras) => {
    this.events.items(this.eventType.onReceivePhotoComplete).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      url: Paras.v_strURL,
    });
  };

  this.QueryResourceListAck = (Paras) => {
    this.events.items(this.eventType.onQueryResourceListAck).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      result: Paras.v_byResult,
      param: Paras.v_aParam,
    });
  };

  this.RemoteVideoReplayAck = (Paras,request) => {
    this.events.items(this.eventType.onRemoteVideoReplayAck).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      result: Paras.v_byResult, 
      request:request
    });
  };

  this.RemoteVideoReplayControlAck = (Paras,request) => {
    this.events.items(this.eventType.onRemoteVideoReplayControlAck).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      result: Paras.v_byResult,
      request:request
    });
  };

  this.RealTimeMultiMediaDeviceTransferAck = (Paras,request) => {
    this.events.items(this.eventType.onRealTimeMultiMediaDeviceTransferAck).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      result: Paras.v_byResult,
      request:request
    });
  };

  this.MultiMediaDeviceRealTimeTransferControlAck = (Paras,request) => {
    this.events.items(this.eventType.onMultiMediaDeviceRealTimeTransferControlAck).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      result: Paras.v_byResult,
      request:request
    });
  };

  this.QueryMultiMediaDeviceParamAck = (Paras) => {
    this.events.items(this.eventType.onQueryMultiMediaDeviceParamAck).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      result: Paras.v_byResult,
      param: Paras.v_aParam,
    });
  };

  this.SendInfomationAck = (Paras) => {
    this.events.items(this.eventType.onSendInfomationAck).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      result: Paras.v_byResult,
    });
  };

  this.VelOnlineStateAck = (Paras) => {
    this.events.items(this.eventType.onVelOnlineStateAck).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      result: Paras.v_byResult,
      count: Paras.v_uiCount,
      param: Paras.v_aParam,
    });
  };

  //1078协议 多媒体文件上传指令应答 0x9206
  this.MultiMediaFileUploadAck = (Paras, request) => {
    this.events.items(this.eventType.onMultiMediaFileUploadAck).run({
      mobile: Paras.v_strPhone,
      msgId: Paras.v_strMsgID,
      result: Paras.v_byResult,
      request: request,
    });
  };

  //1078协议 报警附件上传完成通知 0x1204
  // this.AlarmFileUploadCompleteNotify = (Paras) => {
  //   this.events.items(this.eventType.onAlarmFileUploadCompleteAck).run({
  //     mobile: Paras.v_strPhone,
  //     msgId: Paras.v_strMsgID,
  //     result: Paras.v_byResult,
  //     fileName: Paras.v_strFileName,
  //     fileSize: Paras.v_uiFileSize,
  //   });
  // };


  //websocket应答
  this.WebSocketAck = (resp,request) => {
    // console.log(resp);
    // console.log(request);
    var functionName = resp.Method;
    if (typeof this[functionName] === "function") {
      this[functionName](resp.Paras,request);
    }
  };
}

export { SocketAck };
